import React from 'react';
import { useNavigate } from 'react-router-dom';

const ApplyNow = () => {


    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/mobileVerification');
    };

    return (
        <div className="pt-0 w-screen h-screen py-12 flex justify-center md:mt-40">
            <div className="bg-white flex flex-col md:flex-row">
                <div className="md:w-1/2 p-6 md:p-40 w-full h-full text-center md:text-left">
                    <h1 className="text-3xl font-extrabold mb-6 text-blue-800">
                        Welcome to Yaazh Finance
                    </h1>
                </div>
                <div className="md:w-1/2 p-6 w-full">
                    <p className="mb-4 text-blue-900 font-bold text-2xl text-center">
                        Here are a few things you will need to get started:
                    </p>
                    <ul className="list-disc list-inside mb-8 text-gray-700 space-y-2 py-10">
                        <li className='lg:py-2'>Mobile Verification</li>
                        <li className='lg:py-2'>Email Verification Form</li>
                        <li className='lg:py-2'>Loan Informations</li>
                        <li className='lg:py-2'>PAN Card</li>
                        <li className='g:py-2'>Personal Informations</li>
                        <li className='lg:py-2'>About Your Work</li>
                        <li className='lg:py-2'>Have You Borrowed Before?</li>
                        <li className='lg:py-2'>Proof Of Residence Form</li>
                        <li className='lg:py-2'>Bank Details</li>
                        <li className='lg:py-2'>Upload Documents</li>
                       
                    </ul>
                    <div className='mt-0'>
                        <button onClick={handleButtonClick} className="w-full bg-gradient-to-r from-blue-900 to-blue-900 text-white py-3 rounded-xl font-semibold duration-300">
                            GET STARTED
                        </button>
                    </div>
                </div>
            </div>
        </div>


    );

}

export default ApplyNow;
